module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "d-flex bold mb-3 mt-1"
  }, [_vm._v("\n    Ticket Summary\n\n    "), (_vm.tag) ? _c('span', {
    staticClass: "ml-auto"
  }, [_vm._v("Dummy Vehicle")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-782d0fb8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-782d0fb8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/summary/SummaryHeader.vue
// module id = 2819
// module chunks = 0